import type {AxiosRequestConfig} from 'axios';
import {User, Status} from './interface';

export class DeleteUserBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.usersRequest.url = `/users/${id}`;
    return this;
  }
  build() {
    return this.usersRequest;
  }
}
export class GetAllUsersRequestBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/users',
    params: {},
  };

  id(id: number) {
    this.usersRequest.url = `/users/${id}`;
    return this;
  }
  params(params: object) {
    this.usersRequest.params = params;
    return this;
  }

  build() {
    return this.usersRequest;
  }
}
export class GetUsersCountRequestBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/users/count',
    params: {},
  };
  params(params: object) {
    this.usersRequest.params = params;
    return this;
  }

  build() {
    return this.usersRequest;
  }
}
export class GetUserProfileRequestBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/users/profile',
    params: {},
  };

  build() {
    return this.usersRequest;
  }
}

export class UpdateUserProfileRequestBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/users/profile',
    data: {},
  };

  data(data: User) {
    this.usersRequest.data = data;
    return this;
  }

  build() {
    return this.usersRequest;
  }
}

export class CreateUserRequestBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/users',
    data: {},
  };

  data(data: User) {
    this.usersRequest.data = data;
    return this;
  }

  build() {
    return this.usersRequest;
  }
}

export class UpdateUserRequestBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/users',
    data: {},
  };
  data(body: User) {
    this.usersRequest.data = body;
    return this;
  }
  build() {
    return this.usersRequest;
  }
}

export class UpdateUserStatusRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };
  id(id: number) {
    this.request.url = `/users/${id}/status`;
    return this;
  }
  data(body: Status) {
    this.request.data = `"${body}"`;
    return this;
  }
  build() {
    return this.request;
  }
}
